import { API_URL } from '../../../../constants';

const paths = {
  getTrafficLights: () => `${API_URL}/employee-traffic-lights`,
};

export default paths;
